import {Subscription} from "rxjs";
import {RouterLink} from "@angular/router";
import {DatePipe, NgClass} from "@angular/common";
import {Component, inject, OnDestroy, OnInit} from '@angular/core';

import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

import {appRoutes} from "@numizmat/constants";
import {BidApiService} from "@numizmat/services/core";
import {CurrentUser} from "@numizmat/services-models/account";
import {CurrentUserStateService} from "@numizmat/services/account";
import {BidResponse, PublicAdDetailResponse} from "@numizmat/services-models/core";
import {AdDetailStateService} from "@numizmat/services/core/ad-detail/ad-detail-state.service";

@Component({
  selector: 'nz-bid-history-modal',
  standalone: true,
  imports: [
    DatePipe,
    RouterLink,
    NgClass
  ],
  templateUrl: './bid-history-modal.component.html',
  styleUrl: './bid-history-modal.component.scss'
})
export class BidHistoryModalComponent implements OnInit, OnDestroy {
  private activeModal: NgbActiveModal = inject(NgbActiveModal);
  private bidApiService: BidApiService = inject(BidApiService);
  private adDetailStateService: AdDetailStateService = inject(AdDetailStateService);
  private currentUserStateService: CurrentUserStateService = inject(CurrentUserStateService);

  private subs: Subscription = new Subscription();

  protected adId!: string;
  protected loading: boolean = true;
  protected bids: BidResponse[] = [];
  protected currentUser!: CurrentUser;
  protected adDetails!: PublicAdDetailResponse;

  protected readonly appRoutes = appRoutes;

  public ngOnInit(): void {
    this.getAllBids();
    this.getCurrentUser();
    this.getPublicAdDetails();
  }

  public ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  protected closeModal(): void {
    this.activeModal.dismiss();
  }

  private getAllBids(): void {
    this.bidApiService.getAllBids(this.adId).subscribe({
      next: (response: BidResponse[]) => {
        this.loading = false;
        this.bids = response;
        let isCurrentAuctionWinner: boolean = false;
        if (this.currentUser.loggedIn) {
          isCurrentAuctionWinner = this.bids[0].userId === this.currentUser.userData?.userId;
        }
        this.adDetailStateService.setPublicAdDetails({
          ...this.adDetails,
          price: this.bids[0].amount,
          bidCount: this.bids.length,
          isCurrentAuctionWinner: isCurrentAuctionWinner
        });
      }
    });
  }

  private getCurrentUser(): void {
    const subscription: Subscription = this.currentUserStateService.getCurrentUser().subscribe({
      next: currentUser => {
        this.currentUser = currentUser;
      }
    });
    this.subs.add(subscription);
  }

  private getPublicAdDetails(): void {
    const subscription: Subscription = this.adDetailStateService.getPublicAdDetails().subscribe({
      next: (adDetails: PublicAdDetailResponse | undefined) => {
        if (!!adDetails) {
          this.adDetails = adDetails;
        }
      }
    });
    this.subs.add(subscription);
  }
}
